var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWifi = function SvgWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.4 19.8-2.3-2.3c-.4-.4-.3-1 .1-1.2 1.7-1.1 3.9-1.1 5.6 0 .4.3.5.9.1 1.2l-2.3 2.3c-.3.3-.9.3-1.2 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 15.2c-.4 0-.7-.1-1-.4-1.5-1.5-3.5-2.3-5.5-2.3s-4.1.8-5.5 2.3c-.6.6-1.5.6-2 0s-.6-1.5 0-2c2-2 4.7-3.1 7.6-3.1s5.6 1.1 7.6 3.1c.6.6.6 1.5 0 2-.4.3-.8.4-1.2.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6 11.2c-.4 0-.7-.1-1-.4-2.5-2.5-6-4-9.6-4s-7 1.4-9.6 4c-.6.6-1.5.6-2 0-.6-.6-.6-1.5 0-2C3.5 5.7 7.7 4 12 4s8.5 1.7 11.6 4.8c.6.6.6 1.5 0 2-.3.3-.6.4-1 .4z"
  })));
};
export default SvgWifi;